import React, { useState, useEffect } from "react";
import { Grid, Input, Icon, Button } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useLoginCheck } from "../../../../hooks/useLoginCheck";
import "../../../../styles/scss/recital2026MusicAndPlan.scss";

function MusicAndPlanPage() {
  useLoginCheck();
  const [instructors, setInstructors] = useState([]); // インストラクター

  useEffect(() => {
    console.log(instructors);
  }, [instructors]);

  // インストラクターの取得
  const fetchInstructorData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(
        `${apiUrl}/api/get_recital2026_music_and_plan/`
      );
      if (!response.ok) {
        throw new Error("ネットワークレスポンスが異常です。");
      }
      const data = await response.json();
      setInstructors(data);
    } catch (error) {
      console.error("データの取得中にエラーが発生しました:", error);
    }
  };

  // 初期表示時にインストラクターと参加者のリストを取得
  useEffect(() => {
    fetchInstructorData();
  }, []);

  return (
    <>
      <Grid>
        <h1>発表会2026音源・照明プラン管理</h1>
      </Grid>

      <Grid>
        <Grid.Column width={16}>
          <div className="music-plan-table-wrapper">
            <div className="music-plan-table">
              {instructors.map((instructor) => {
                const numbers = Object.entries(instructor.numbers);

                // URLからファイル名を抽出する関数
                const getFilename = (url) => {
                  if (!url) return "";
                  const parts = url.split("/");
                  return parts[parts.length - 1];
                };

                return (
                  <div key={instructor.id} className="instructor-section">
                    {/* インストラクター名ヘッダー */}
                    <div className="instructor-header">
                      {instructor.username}
                    </div>

                    {/* ナンバー一覧 */}
                    {numbers.map(([numberName, files]) => {
                      // 照明プランの数を取得
                      const planCount =
                        files.plan && files.plan.length > 0
                          ? files.plan.length
                          : 1;

                      return (
                        <div key={numberName} className="number-section">
                          {/* ナンバー名 */}
                          <div
                            className="number-cell"
                            style={{ gridRow: `span ${planCount + 1}` }}
                          >
                            {numberName}
                          </div>

                          {/* 音源 */}
                          <div className="file-type-cell">音源</div>
                          <div className={`file-name-cell ${!(files.music && files.music.s3_url) ? 'not-submitted-cell' : ''}`}>
                            {files.music && files.music.s3_url ? (
                              <a
                                href={files.music.s3_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-link"
                              >
                                {getFilename(files.music.s3_url)}
                              </a>
                            ) : (
                              <span className="not-submitted">未提出</span>
                            )}
                          </div>

                          {/* 照明プラン */}
                          {files.plan && files.plan.length > 0 ? (
                            files.plan.map((planFile, index) => (
                              <React.Fragment key={index}>
                                {index === 0 && (
                                  <div
                                    className="file-type-cell light"
                                    style={{ gridRow: `span ${planCount}` }}
                                  >
                                    照明プラン
                                  </div>
                                )}
                                <div className="file-name-cell">
                                  <a
                                    href={planFile.s3_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="file-link"
                                  >
                                    {getFilename(planFile.s3_url)}
                                  </a>
                                </div>
                              </React.Fragment>
                            ))
                          ) : (
                            <>
                              <div className="file-type-cell light">
                                照明プラン
                              </div>
                              <div className="file-name-cell not-submitted-cell">
                                <span className="not-submitted">未提出</span>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        </Grid.Column>
      </Grid>
    </>
  );
}

export default MusicAndPlanPage;
